class ClockTime extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTimes = this.setupTimes.bind(this)
    this.setClock = this.setClock.bind(this)
    this.isVisible = false

    this.setupIntersectionObserver()
  }

  setupIntersectionObserver () {
    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.isVisible = entry.isIntersecting
        if (entry.isIntersecting) {
          this.setupTimes()
        } else {
          this.stopClock()
        }
      },
      { rootMargin: '50px' },
    )
    this.observer.observe(this)
  }

  setupTimes () {
    if (!this.els?.time?.exists) return
    if (this.intervalId) return

    this.setClock()
    this.intervalId = setInterval(this.setClock, 1000)
  }

  stopClock () {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  setClock () {
    const currentDate = new Date(
      new Date().toLocaleString('en-US', { timeZone: this.dataset.timezone }),
    )

    this.els.time.elements.forEach((timeEl) => {
      timeEl.innerText = `${this.padNumber(currentDate.getHours())}:${this.padNumber(currentDate.getMinutes())}:${this.padNumber(currentDate.getSeconds())}`
    })
  }

  padNumber (number) {
    return number < 10 ? `0${number}` : number
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }
}

if (!customElements.get('clock-time')) {
  customElements.define('clock-time', ClockTime)
}
